import { render, staticRenderFns } from "./UncannyAutomator.vue?vue&type=template&id=5140a2ac&scoped=true"
import script from "./UncannyAutomator.vue?vue&type=script&lang=js"
export * from "./UncannyAutomator.vue?vue&type=script&lang=js"
import style0 from "./UncannyAutomator.vue?vue&type=style&index=0&id=5140a2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140a2ac",
  null
  
)

export default component.exports